import { IHisInfoGroupBehavior } from ".";
import { User } from "../../../user";
import { HisInformationItem } from "../..";
import { Department } from "../../../department";
import { IHisInformationApplicable } from "../../../document/items";

/**
 * 医療機関_医師名・作成者・医師選択の選択時に
 * カナ氏名・診療科名称・診療科選択をグループ入力するために
 * HIS情報を生成する。
 */
export class DoctorBehavior implements IHisInfoGroupBehavior {
  private userKanaNameKey = "USER_KANA_NAME";
  private srykaNameKey = "SRYKA_NAME";
  private srykaSelectKey = "SRYKA_SELECT";

  private groupKeys = [ this.userKanaNameKey, this.srykaNameKey, this.srykaSelectKey ];

  constructor(private key: string, private users: User[], private department: Department) {}

  createHisInfoItems(): HisInformationItem[] {
    if (this.users === null) { return [ new HisInformationItem(this.key, "") ]; }

    const nameItems = this.users.map(x => new HisInformationItem(this.key, x.name));
    const kanaItems = this.users.map(x => new HisInformationItem(this.userKanaNameKey, x.kanaName));
    const srykaItems = [ this.srykaNameKey, this.srykaSelectKey ]
      .map(x => new HisInformationItem(x, (this.department != null) ? this.department.name : ""));
    const items = nameItems
      .concat(kanaItems)
      .concat(srykaItems);
    return items;
  }

  areSameGroup(item: IHisInformationApplicable): boolean {
    return this.groupKeys.indexOf(item.hisItemParameter.key) >= 0;
  }
}
